<template>
<div class="col-md-12 p-l-r-0 f-left">
    <div class="col-md-12 p-l-r-0 f-left">
        <div class="form-group col-md-6 p-l-r-0 f-left">
            <label for="proposed-business">Registered office address of proposed business* </label>
            <select id="acc-type" name="account_type" class="form-control" @change="onChange($event)" v-model="Rental">
                <option value="Rental Agreement">Rental Agreement</option>
                <option value="Property tax">Property tax</option>
            </select>
			<span class="text-danger" v-if="other_validation_err.registered_office">Please select one option</span>
        </div>
        <div class="form-group col-md-6 p-r-0 f-left choosefile-upload">
            <label class="lable-full-width">{{Rental}}</label>
            <input type="file" ref="aggrement" hidden @change="getFile('aggrement')" />
            <label class="choose-btn" @click="$refs.aggrement.click()">Choose file</label>
            <br>
            <span id="file-chosen" v-if="rental_url">
                <a :href="rental_url" target="_blank" class="aggrement_view">View</a>
            </span>
            <span class="text-danger" v-if="other_validation_err.registered_office_doc_url">Please upload the document</span>
        </div>
    </div>
    <div class="col-md-12 p-l-r-0 f-left">
        <div class="form-group col-md-12 p-l-r-0 f-left choosefile-upload utility">
            <label class="lable-full-width">Any Utility Bill*</label>
            <input type="file" ref="utility" hidden @change="getFile('Utility bill')" />
            <label class="choose-btn" @click="$refs.utility.click()">Choose file</label>
            <span class="teptext">(Not older than 2 months)</span>
			<span id="file-chosen" v-if="utility">
				<a :href="utility" target="_blank">View</a>
			</span>
            <span class="text-danger" v-if="other_validation_err.any_utility_bill_url">Please upload any utility bill</span>
        </div>
        <div class="form-group col-md-12 p-l-r-0 f-left choosefile-upload otherbills">
            <label class="lable-full-width">NOC if rented premise or property tax receipt (if business premise self owned)*</label>
            <div class="f-left">
                <input type="file" ref="noc" hidden @change="getFile('NOC')" />
                <label class="choose-btn" @click="$refs.noc.click()">Choose file</label>
				<span id="file-chosen" v-if="noc">
				<a :href="noc" target="_blank">View</a>
			</span>
            </div>
          
            <div class="f-left download_document"><a href="#"><img src="../assets/download_icon.png">Download the format</a></div>
            <span class="f-left teptext" style="width: 100%;">(from landlord for use of premise)</span>
              <span class="text-danger" v-if="other_validation_err.noc" style="display: block;float: left;">Please upload  document</span>
        </div>
        <div class="form-group col-md-12 p-l-r-0 f-left choosefile-upload otherbills" v-if="parentName !='llpagreement' && parentName !='partnershipagreement'">
            <label class="lable-full-width">Authorization Letter*</label>
            <div class="f-left">
                <input type="file" ref="authorization_letter" hidden @change="getFile('Authorization letter')" />
                <label class="choose-btn" @click="$refs.authorization_letter.click()">Choose file</label>
				<span id="file-chosen" v-if="Authorization">
				<a :href="Authorization" target="_blank">View</a>
			</span>
            </div>
            <div class="f-left download_document"><a href="#"><img src="../assets/download_icon.png">Download the format</a></div>
             <span class="text-danger" v-if="other_validation_err.authorization_letter_url"  style="display: block;float: left;width: 100%">Please upload  document</span>
        </div>
    </div>

</div>
</template>

<script>
import file from '../services/fileupload'
import ls from '../services/ls'
export default {
    name: 'bills_agreement',
    props: ["parentName", 'propdata','owner_information',"other_validation"],
    watch: {
        owner_information: {
            handler: function () {
                this.UpdateChildPropData();
            },
            immediate: true
        },
        other_validation: {
            handler: function (data) {
               this.UpdateError(data)
            },
            immediate: true
        },
    },
    data() {
        return {
            Rental: "Rental Agreement",
            utility: "",
            rental_url: "",
            noc: "",
            Authorization: "",
            other_validation_err:{}
        }
    },
    methods: {
		UpdateChildPropData(){
			if(this.owner_information)
            {
                this.Rental=this.owner_information.registered_office
                this.utility=this.owner_information.any_utility_bill_url
                this.rental_url=this.owner_information.registered_office_doc_url
                this.noc=this.owner_information.noc
                this.Authorization=this.owner_information.authorization_letter_url
            }
			
		},
        UpdateError(data){
            this.other_validation_err=data
        },
        onChange(event) {
            this.Rental = event.target.value
            this.SentTOparent(event.target.value);
        },
        SentTOparent(data) {
            this.$emit("UpdateFilePath", {
                src: 'registered_office',
                url: data,
            });
        },
        getFile(doc_type) {
            var src_file = '';
            var src = "";
            if (doc_type == 'aggrement') {
                src_file = this.$refs.aggrement.files;
                src = 'registered_office_doc_url';
            }
            if (doc_type == 'Utility bill') {
                src_file = this.$refs.utility.files;
                src = 'any_utility_bill_url';
            }
            if (doc_type == 'NOC') {
                src_file = this.$refs.noc.files;
                src = 'noc';
            }
            if (doc_type == 'Authorization letter') {
                src_file = this.$refs.authorization_letter.files;
                src = 'authorization_letter_url';
            }
            let formData = new FormData();
            for (var i = 0; i < src_file.length; i++) {
                let file = src_file[i];
                formData.append('files[' + i + ']', file);
            }
            formData.append('subscription_id', this.propdata.subscribtion_id)
            formData.append('slug', this.propdata.type)
            formData.append('folder_id', this.propdata.folder_id)
            formData.append('session_user', ls.get('_u_unique'));
            formData.append('label', doc_type);
            file.uploadProofs(formData)
                .then(response => {
                    this.$emit("UpdateFilePath", {
                        src: src,
                        url: response.data.file_url,
                    });
                })
        },
    }
};
</script>
